import { has } from 'lodash';

type Item = {};

const isLikelyToBeParentPerAction = (action: string | undefined) =>
  // Node action (from the prefill)
  action === 'folder' || action === 'folderList' || action === 'directory';

const isLikelyToBeOneDriveParent = (item: Item, index: number) =>
  index === 0 && has(item, '_path');

export default function isPrefillChoiceParent(
  action: string | undefined,
  item: Item,
  index: number
) {
  return (
    isLikelyToBeParentPerAction(action) &&
    isLikelyToBeOneDriveParent(item, index)
  );
}
